/* =============================================================
   STREETWISE COLLECTION FILTER SIDEBAR
   File: assets/collection-filter-sidebar.js
   ============================================================= */

(function () {
  'use strict';

  // ── State ──────────────────────────────────────────────────
  const state = {
    sortBy: 'default',
    types: [],
    priceMin: null,
    priceMax: null,
    inStockOnly: false,
  };

  // ── DOM refs ───────────────────────────────────────────────
  const grid = document.querySelector('.sw-filter-product-grid');
  const allCards = () => Array.from(document.querySelectorAll('.sw-filter-product-grid .product-card'));
  const resultsCount = document.querySelector('.sw-filter-results-count');
  const noResults = document.querySelector('.sw-filter-no-results');
  const chipsContainer = document.querySelector('.sw-filter-chips');
  const clearAllBtn = document.querySelector('.sw-filter-clear-all');
  const mobileBadge = document.querySelector('.sw-filter-mobile-badge');

  // ── Apply filters ──────────────────────────────────────────
  function applyFilters() {
    const cards = allCards();
    let visible = 0;

    // First sort
    const sorted = sortCards(cards);
    sorted.forEach((card, i) => {
      card.style.order = i;
    });

    // Then filter
    cards.forEach(card => {
      const show = matchesFilters(card);
      card.classList.toggle('sw-filtered-out', !show);
      if (show) visible++;
    });

    // Update count
    if (resultsCount) {
      resultsCount.innerHTML = `Showing <strong>${visible}</strong> of <strong>${cards.length}</strong> products`;
    }

    // No results state
    if (noResults) {
      noResults.classList.toggle('visible', visible === 0);
    }

    // Update chips
    updateChips();

    // Update mobile badge
    const activeCount = countActiveFilters();
    if (mobileBadge) {
      mobileBadge.textContent = activeCount;
      mobileBadge.classList.toggle('visible', activeCount > 0);
    }

    // Clear all button visibility
    if (clearAllBtn) {
      clearAllBtn.classList.toggle('hidden', activeCount === 0);
    }

    // Update drawer apply button count
    const applyBtn = document.querySelector('.sw-filter-drawer__apply');
    if (applyBtn) {
      applyBtn.textContent = visible === cards.length
        ? 'Apply Filters'
        : `Show ${visible} Products`;
    }
  }

  function matchesFilters(card) {
    const price = parseInt(card.dataset.price || '0', 10) / 100;
    const type = (card.dataset.type || '').toLowerCase().replace(/-/g, ' ');
    const inStock = card.dataset.inStock !== 'false';

    // Type filter
    if (state.types.length > 0) {
      const normalizedTypes = state.types.map(t => t.toLowerCase().replace(/-/g, ' '));
      if (!normalizedTypes.includes(type)) return false;
    }

    // Price filter
    if (state.priceMin !== null && price < state.priceMin) return false;
    if (state.priceMax !== null && price > state.priceMax) return false;

    // Availability
    if (state.inStockOnly && !inStock) return false;

    return true;
  }

  function sortCards(cards) {
    const sorted = [...cards];
    switch (state.sortBy) {
      case 'price-asc':
        sorted.sort((a, b) => parseInt(a.dataset.price) - parseInt(b.dataset.price));
        break;
      case 'price-desc':
        sorted.sort((a, b) => parseInt(b.dataset.price) - parseInt(a.dataset.price));
        break;
      case 'newest':
        sorted.sort((a, b) => parseInt(b.dataset.created || '0') - parseInt(a.dataset.created || '0'));
        break;
      case 'best-selling':
        sorted.sort((a, b) => parseInt(a.dataset.index || '0') - parseInt(b.dataset.index || '0'));
        break;
      case 'rating':
        sorted.sort((a, b) => parseFloat(b.dataset.rating || '0') - parseFloat(a.dataset.rating || '0'));
        break;
      default:
        sorted.sort((a, b) => parseInt(a.dataset.index || '0') - parseInt(b.dataset.index || '0'));
    }
    return sorted;
  }

  function countActiveFilters() {
    let count = 0;
    if (state.types.length > 0) count += state.types.length;
    if (state.priceMin !== null || state.priceMax !== null) count++;
    if (state.inStockOnly) count++;
    if (state.sortBy !== 'default') count++;
    return count;
  }

  // ── Chips ──────────────────────────────────────────────────
  function updateChips() {
    if (!chipsContainer) return;
    chipsContainer.innerHTML = '';
    const chips = [];

    // Sort chip
    if (state.sortBy !== 'default') {
      const labels = {
        'price-asc': 'Price: Low to High',
        'price-desc': 'Price: High to Low',
        'newest': 'Newest',
        'best-selling': 'Best Selling',
        'rating': 'Top Rated',
      };
      chips.push({ label: labels[state.sortBy] || state.sortBy, remove: () => { state.sortBy = 'default'; syncSortUI(); } });
    }

    // Type chips
    state.types.forEach(type => {
      chips.push({
        label: type,
        remove: () => {
          state.types = state.types.filter(t => t !== type);
          syncTypeUI();
        }
      });
    });

    // Price chip
    if (state.priceMin !== null || state.priceMax !== null) {
      const min = state.priceMin !== null ? `$${state.priceMin}` : '$0';
      const max = state.priceMax !== null ? `$${state.priceMax}` : '+';
      chips.push({
        label: `${min} – ${max}`,
        remove: () => {
          state.priceMin = null;
          state.priceMax = null;
          syncPriceUI();
        }
      });
    }

    // Availability chip
    if (state.inStockOnly) {
      chips.push({ label: 'In Stock', remove: () => { state.inStockOnly = false; syncAvailabilityUI(); } });
    }

    chips.forEach(chip => {
      const btn = document.createElement('button');
      btn.className = 'sw-filter-chip';
      btn.innerHTML = `${chip.label}<span class="sw-filter-chip__remove">✕</span>`;
      btn.addEventListener('click', () => { chip.remove(); applyFilters(); });
      chipsContainer.appendChild(btn);
    });

    chipsContainer.classList.toggle('visible', chips.length > 0);
  }

  // ── UI sync helpers ────────────────────────────────────────
  function syncSortUI() {
    document.querySelectorAll('.sw-filter-sort-select').forEach(sel => {
      sel.value = state.sortBy;
    });
  }

  function syncTypeUI() {
    document.querySelectorAll('input[data-filter="type"]').forEach(cb => {
      cb.checked = state.types.includes(cb.value);
    });
  }

  function syncPriceUI() {
    document.querySelectorAll('.sw-filter-price-preset').forEach(btn => {
      btn.classList.remove('active');
    });
    document.querySelectorAll('.sw-price-min').forEach(el => el.value = '');
    document.querySelectorAll('.sw-price-max').forEach(el => el.value = '');
  }

  function syncAvailabilityUI() {
    document.querySelectorAll('input[data-filter="availability"]').forEach(cb => {
      cb.checked = state.inStockOnly;
    });
  }

  // ── Clear all ──────────────────────────────────────────────
  function clearAll() {
    state.sortBy = 'default';
    state.types = [];
    state.priceMin = null;
    state.priceMax = null;
    state.inStockOnly = false;
    syncSortUI();
    syncTypeUI();
    syncPriceUI();
    syncAvailabilityUI();
    applyFilters();
  }

  // ── Event bindings ─────────────────────────────────────────
  function bindEvents() {
    // Sort selects
    document.querySelectorAll('.sw-filter-sort-select').forEach(sel => {
      sel.addEventListener('change', e => {
        state.sortBy = e.target.value;
        syncSortUI();
        applyFilters();
      });
    });

    // Type checkboxes
    document.querySelectorAll('input[data-filter="type"]').forEach(cb => {
      cb.addEventListener('change', e => {
        if (e.target.checked) {
          if (!state.types.includes(e.target.value)) state.types.push(e.target.value);
        } else {
          state.types = state.types.filter(t => t !== e.target.value);
        }
        applyFilters();
      });
    });

    // Price presets
    document.querySelectorAll('.sw-filter-price-preset').forEach(btn => {
      btn.addEventListener('click', () => {
        const min = btn.dataset.min ? parseInt(btn.dataset.min) : null;
        const max = btn.dataset.max ? parseInt(btn.dataset.max) : null;

        // Toggle off if already active
        if (state.priceMin === min && state.priceMax === max) {
          state.priceMin = null;
          state.priceMax = null;
          document.querySelectorAll('.sw-filter-price-preset').forEach(b => b.classList.remove('active'));
        } else {
          state.priceMin = min;
          state.priceMax = max;
          document.querySelectorAll('.sw-filter-price-preset').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          // Sync inputs
          document.querySelectorAll('.sw-price-min').forEach(el => el.value = min !== null ? min : '');
          document.querySelectorAll('.sw-price-max').forEach(el => el.value = max !== null ? max : '');
        }
        applyFilters();
      });
    });

    // Price apply buttons
    document.querySelectorAll('.sw-filter-price-apply').forEach(btn => {
      btn.addEventListener('click', () => {
        const minInput = btn.closest('.sw-filter-group__body, .sw-filter-drawer__body')
          ?.querySelector('.sw-price-min');
        const maxInput = btn.closest('.sw-filter-group__body, .sw-filter-drawer__body')
          ?.querySelector('.sw-price-max');
        const min = minInput && minInput.value !== '' ? parseFloat(minInput.value) : null;
        const max = maxInput && maxInput.value !== '' ? parseFloat(maxInput.value) : null;
        state.priceMin = min;
        state.priceMax = max;
        document.querySelectorAll('.sw-filter-price-preset').forEach(b => b.classList.remove('active'));
        applyFilters();
      });
    });

    // Availability
    document.querySelectorAll('input[data-filter="availability"]').forEach(cb => {
      cb.addEventListener('change', e => {
        state.inStockOnly = e.target.checked;
        syncAvailabilityUI();
        applyFilters();
      });
    });

    // Clear all
    document.querySelectorAll('.sw-filter-clear-all, .sw-filter-drawer__reset').forEach(btn => {
      btn.addEventListener('click', clearAll);
    });

    // No results clear
    const noResultsClear = document.querySelector('.sw-filter-no-results button');
    if (noResultsClear) noResultsClear.addEventListener('click', clearAll);

    // Group toggles (collapse/expand)
    document.querySelectorAll('.sw-filter-group__toggle').forEach(btn => {
      btn.addEventListener('click', () => {
        btn.closest('.sw-filter-group').classList.toggle('collapsed');
        const chevron = btn.querySelector('.sw-filter-group__chevron');
      });
    });

    // Mobile drawer
    const mobileToggle = document.querySelector('.sw-filter-mobile-toggle');
    const drawerOverlay = document.querySelector('.sw-filter-drawer-overlay');
    const drawer = document.querySelector('.sw-filter-drawer');
    const drawerClose = document.querySelector('.sw-filter-drawer__close');
    const drawerApply = document.querySelector('.sw-filter-drawer__apply');

    if (mobileToggle && drawer && drawerOverlay) {
      mobileToggle.addEventListener('click', () => {
        drawerOverlay.classList.add('open');
        drawer.classList.add('open');
        document.body.style.overflow = 'hidden';
      });

      const closeDrawer = () => {
        drawerOverlay.classList.remove('open');
        drawer.classList.remove('open');
        document.body.style.overflow = '';
      };

      drawerOverlay.addEventListener('click', closeDrawer);
      if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
      if (drawerApply) drawerApply.addEventListener('click', closeDrawer);
    }
  }

  // ── Init ───────────────────────────────────────────────────
  function init() {
    if (!grid) return;

    // Tag all cards with index for sort reset
    allCards().forEach((card, i) => {
      if (!card.dataset.index) card.dataset.index = i;
    });

    bindEvents();
    applyFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();